// 全局常量
export const Constant = {
  TokenKey: "access_token",
  Uid: "uid",
  ThemeKey: "dark",
};
// 文件类型
export const FileTypeMap = {
  bpm: "image/bpm",
  png: "image/png",
  jpg: "image/jpeg",
  gif: "image/gif",
  mp3: "audio/mp3",
  mp4: "video/mpeg4",
  aac: "audio/x-mei-aac",
};

export enum MaterialTypeEnum {
  "video" = "MOVIE",
  "audio" = "MUSIC",
  "audioEffect" = "AUDIOEFFECT",
  "image" = "PICTURE",
  "sticker" = "STICKER",
  "effect" = "EFFECT",
  "background" = "BACKGROUND",
  "text" = "TEXT",
  "picInPic" = "PICINPIC",
  "thumb" = "THUMB",
  "narrator" = "NARRATOR",
  "transition" = "TRANSITION",
  "template" = "TEMPLATE",
  "filter" = "FILTER",
}

export const getMaterialType = (type: MaterialTypeEnum) => {
  switch (type) {
    case MaterialTypeEnum.video:
      return "video";
    case MaterialTypeEnum.audio:
      return "audio";
    case MaterialTypeEnum.audioEffect:
      return "audioEffect";
    case MaterialTypeEnum.image:
      return "image";
    case MaterialTypeEnum.sticker:
      return "sticker";
    case MaterialTypeEnum.effect:
      return "effect";
    case MaterialTypeEnum.background:
      return "background";
    case MaterialTypeEnum.text:
      return "text";
    case MaterialTypeEnum.picInPic:
      return "picInPic";
    case MaterialTypeEnum.thumb:
      return "thumb";
    case MaterialTypeEnum.narrator:
      return "narrator";
    case MaterialTypeEnum.transition:
      return "transition";
    case MaterialTypeEnum.template:
      return "template";
    case MaterialTypeEnum.filter:
      return "filter";
  }
};

export const defaultMoveOptions = {
  draggable: true,
  resizable: false,
  scalable: true,
  dragArea: false, // 开启 控制拖动区域
  origin: false, // 原点是否可见
  snappable: true, // 开启辅助线
  stopPropagation: true, // 阻止冒泡
  snapThreshold: 5,
  isDisplaySnapDigit: true, // 是否显示辅助线距离
  snapGap: true, // 画块辅助线
  snapElement: true, // 基于元素的辅助线
  snapCenter: true, // 中心辅助线
  snapDigit: 10, // 吸附距离
  snapVertical: true, // 垂直辅助线
  snapHorizontal: true, // 水平辅助线
  throttleDrag: 1,
  throttleResize: 1,
  throttleScale: 0.01,
  keepRatio: true, // 保持宽高比
  renderDirections: ["nw", "ne", "se", "sw"], // 手柄锚点
  rotatable: false, // 是否可旋转
  throttleRotate: 0.2,
  elementGuidelines: [],
  pinchable: false, // 捏合开关
};
